import { ListeProceduresResponseModel } from '../../listeProcedures/types/filtresListeProceduresModel'
import axios from 'axios'

export const getAdditionalInfosProcedure = (data: ListeProceduresResponseModel): Promise<ListeProceduresResponseModel> => axios.post('/api/procedure/getAdditionalInformation', data).then((response) => response.data)